export default __webpack_public_path__ + "static/media/1128040325513319.d8f417b3.jpg";